import { IconButton } from "@evergis/ui";
import styled from "styled-components";

export const StyledIconButton = styled(IconButton)<{ fixedWidth?: boolean }>`
  width: ${({ fixedWidth }) => fixedWidth && "2rem"};
`;
